export const SCROLL_SECTIONS = [
  { id: 'events', label: 'Tech Agenda' },
  { id: 'reviews', label: 'R&R' },
] as const;
